

module.exports = __webpack_require__.stylable.create(
    "Cta1247838702",
    {"classes":{"root":"Cta1247838702__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    8,
    "Cta1247838702",
    null
);
